import { ImageDataDto } from '../image/Image';

export enum Role {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
  USER = 'USER',
}

export enum Membership {
  ACTIVE = 'ACTIVE',
  PROSPECTIVE = 'PROSPECTIVE',
  PASSIVE = 'PASSIVE',
  DEACTIVATED = 'DEACTIVATED',
  NOT_ACTIVE = 'NOT_ACTIVE',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}

export interface Account {
  id?: number;
  publicId?: string;
  created?: string;
  createdByEMail?: string;
  updated?: string;
  updatedByEMail?: string;
  keycloakId: string;
  email: string;
  firstname: string;
  name: string;
  username: string;
  member: boolean;
}

export interface UserProfile {
  id?: number;
  publicId?: string;
  created?: string;
  createdByEMail?: string;
  updated?: string;
  updatedByEMail?: string;
  keycloakId: string;
  username: string;
  email: string;
  phone: string;
  firstname: string;
  name: string;
  gender: Gender;
  membership: Membership;
  birthdate: string;
  birthplace: string;
  account: Account;
  // Address data
  addressId: string;
  addressPublicId: string;
  addressCreated: string;
  addressCreatedByEMail: string;
  addressUpdated: string;
  addressUpdatedByEMail: string;
  street: string;
  streetNumber: string;
  city: string;
  bic: string;
  addressAdd: string;
  image: ImageDataDto;
}
